// Content for the MW help panel (components/TriloChatHelpPanel.js). Kept as data
// so the copy can be edited without touching the panel's markup.

// `tag` doubles as the BEM modifier on .trilochat__help-label-tag in chat.scss.
export const MW_HELP_LABELS = [
  {
    tag: "data",
    label: "[DATA]",
    description:
      "Numbers and findings from the study rules engine. Fixed — you can rely on these.",
  },
  {
    tag: "assessment",
    label: "[ASSESSMENT]",
    description:
      "The assistant's clinical interpretation. Requires your review before acting on it.",
  },
  {
    tag: "draft",
    label: "[DRAFT]",
    description: "Text ready for the CSR, shown for your approval.",
  },
  {
    tag: "cioms",
    label: "[CIOMS]",
    description:
      "A patient-level detail quoted or closely paraphrased from a Patient Narrative or CIOMS source document.",
  },
];

export const MW_HELP_EXAMPLE_PROMPTS = [
  {
    heading: "Overview",
    prompts: [
      "What studies do I have?",
      "Show me the status of FAB DRUG DEMO STUDY",
      "Which sections have errors in my study?",
    ],
  },
  {
    heading: "Protocol Deviations",
    prompts: [
      "Review the protocol deviations for [study name]",
      "Show me all the decisions recorded so far",
    ],
  },
  {
    heading: "Demographics",
    prompts: [
      "Review the demographics for [study name]",
      "The clinical team confirmed the BMI difference is not relevant — record that",
    ],
  },
  {
    heading: "Adverse Events",
    prompts: ["Review the adverse events for [study name]"],
  },
  {
    heading: "Efficacy",
    prompts: ["Review the secondary efficacy for [study name]"],
  },
  {
    heading: "Documents & Sections",
    prompts: [
      "What documents have been uploaded for [study name]?",
      "Show me the Introduction section of [study name]",
      "Why does the serious adverse events section show what it shows?",
    ],
  },
  {
    heading: "Comparing studies",
    prompts: ["Compare the wizard answers between [study A] and [study B]"],
  },
  {
    heading: "Patient Narratives",
    prompts: [
      "What does the narrative say about subject 7931-0203-014's death?",
      "Does the narrative set for [narrative set name] cover every death and SAE in the CSR tables?",
      "Check the narrative for [subject] against the CSR",
      "Draft CSR text from the narratives for [narrative set name]",
      "Where does that come from?",
    ],
  },
];

export const MW_HELP_LIMITS = [
  "Conclude that any protocol deviation, adverse event, SAE, or death is unrelated to the study drug — that determination belongs to the clinical team",
  "Insert the standard regulatory sentence without your explicit instruction that the clinical team has confirmed the decision",
  "Use a study ID or Patient Narrative ID in any response — studies and narrative sets are always referred to by name",
  "Mix numbers from different studies without attributing each to its source study by name",
  "Name a specific treatment from a Patient Narrative whose blinding setting is “blinded” — it will say “study treatment” instead, even if the narrative text itself names one",
  "Rephrase or summarise regulated section content",
  "Answer questions outside clinical trial reporting — it will redirect to study review",
];

export const MW_HELP_INTRO =
  "You never need to provide study IDs, Patient Narrative IDs, or technical details — just use the study or narrative set name as you know it.";
